// Sidebar persona card: YOUR PERSONA / PREMISE as values only. Reconfiguring
// lives in the Account Profile, and the whole card is the way there when the
// host passes `onClick`. Presentational — the host passes the config so this
// stays trivially testable.

import type { PersonaConfig } from '@/data/personaConfigTypes';
import { PERSONA_DEFINITIONS, PREMISE_LABELS } from '@/data/personaDefinitions';

export function PersonaCard({
  config,
  onClick,
}: {
  config: PersonaConfig | null;
  onClick?: () => void;
}) {
  if (!config) return null;
  const personaDef = PERSONA_DEFINITIONS[config.persona];
  if (!personaDef) return null;

  // One box, rendered as a button once it has somewhere to go. A button is
  // inline-block by default, so it needs the width back to sit where the div
  // sat under `mx-3`.
  const Box = onClick ? 'button' : 'div';
  const interactive = onClick
    ? ' block w-[calc(100%-1.5rem)] text-left transition-colors hover:bg-white/[0.12]'
    : '';

  return (
    <Box
      {...(onClick ? { type: 'button' as const, onClick } : {})}
      className={`mx-3 mb-1 rounded-[10px] border border-white/[0.13] bg-white/[0.07] px-3 py-2.5${interactive}`}
    >
      <div className="text-[9px] font-bold tracking-[1px] text-sidebar-foreground/50">
        YOUR ROLE
      </div>
      <div className="mt-0.5 text-[15px] font-bold text-sidebar-foreground">
        {personaDef.label}
      </div>
      {config.premise && (
        <div className="mt-1.5 flex items-center gap-2 border-t border-white/[0.13] pt-1.5 text-[12px] font-semibold text-sidebar-foreground">
          <span className="text-[9px] font-bold tracking-[1px] text-sidebar-foreground/50">
            PREMISE
          </span>
          {PREMISE_LABELS[config.premise]}
        </div>
      )}
    </Box>
  );
}
